
import { SecurityTokenDto } from '../../dto/securitytoken/securitytokendto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';


export interface SecurityTokenRequest extends APIRequest
{
    getSecurityTokenRequest(): SecurityTokenDto;
}

export class SecurityTokenRequestImpl extends APIRequestDtoImpl implements SecurityTokenRequest
{
    constructor(private securityTokenData: SecurityTokenDto)
    {
        super();
    }

    getSecurityTokenRequest(): SecurityTokenDto
    {
        return this.securityTokenData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenrequest.tsx